import axios from "axios";
import { IBaseResponse, IUserLiveInfo } from "./types";
import {
  configTiktokUrl,
  confirmTiktokCodeUrl,
  delegateInitializeShares,
  generateTiktokCodeUrl,
  getClientVersionUrl,
  getExploreUrl,
  getLiveInfoUrl,
  getSubscribeUrl,
  getSubscribedUrl,
  getTiktokFollowingUrl,
  getTiktokUserByIdUrl,
  getTiktokUserHoldersByIdUrl,
  getTiktokUserHoldingByIdUrl,
  getTiktokUserTrendingUsersUrl,
  getTiktokUserUpcomingUsersUrl,
  getTwitterAuthUrl,
  getUserActivitiesByIdUrl,
  getUserProfileUrl,
  getUserStatisticUrl,
  getUserTradeByIdUrl,
  getUserUrl,
  getunsubscribeUrl,
  postLoginTwitterUrl,
  searchFantechUsersUrl,
  updateInviteCodeUrl,
} from "./urls";

const getHeaders = (token: string) => {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

export const searchTiktokUsers = async (token: string, searchText: string) => {
  try {
    const res = await axios.get<{ data: any[] }>(
      `${getExploreUrl}?nickname=${searchText}`,
      {
        headers: getHeaders(token),
      }
    );

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const searchFantechUsers = async (token: string, searchText: string) => {
  try {
    const res = await axios.get<{ data: any[] }>(
      `${searchFantechUsersUrl}?nickname=${searchText}`,
      {
        headers: getHeaders(token),
      }
    );

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getUserData = async () => {
  try {
    const res = await axios.get<{ data: any }>(getUserUrl);

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getTiktokFollowingUser = async (
  token: string,
  take: number,
  page: number,
  forceUpdate?: boolean
) => {
  try {
    const res = await axios.get<{ data: any }>(
      `${getTiktokFollowingUrl}?take=${take}&page=${page}${
        forceUpdate ? "&force_update=" + forceUpdate : ""
      }`,
      {
        headers: getHeaders(token),
      }
    );

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getUserProfileData = async (token: string) => {
  try {
    const res = await axios.get<{ data: any }>(getUserProfileUrl, {
      headers: getHeaders(token),
    });

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getUserStatisticData = async (token: string) => {
  try {
    const res = await axios.get<{ data: any }>(getUserStatisticUrl, {
      headers: getHeaders(token),
    });

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserInviteCode = async (token: string, code: string) => {
  try {
    const res = await axios.post<{ data: any }>(
      updateInviteCodeUrl,
      {
        inviteCode: code,
      },
      {
        headers: getHeaders(token),
      }
    );

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const delegateBuyFirstShare = async (token: string) => {
  try {
    const res = await axios.post<{ data: any }>(
      delegateInitializeShares,
      {},
      {
        headers: getHeaders(token),
      }
    );

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const subscribe = async (token: string, idolId: string) => {
  try {
    const res = await axios.post<{ data: any }>(
      getSubscribeUrl,
      {
        idolId,
      },
      {
        headers: getHeaders(token),
      }
    );
    console.log("🚀 ~ file: apis.ts:158 ~ subscribe ~ res:", res);

    return true;
  } catch (error) {
    return false;
  }
};

export const unsubscribe = async (token: string, idolId: string) => {
  try {
    const res = await axios.post<{ data: any }>(
      getunsubscribeUrl,
      {
        idolId,
      },
      {
        headers: getHeaders(token),
      }
    );
    console.log("🚀 ~ file: apis.ts:177 ~ unsubscribe ~ res:", res);

    return true;
  } catch (error) {
    console.log("🚀 ~ file: apis.ts:188 ~ unsubscribe ~ error:", error);
    return false;
  }
};

export const generateTiktokCode = async (token: string) => {
  try {
    const res = await axios.get<{ data: any }>(generateTiktokCodeUrl, {
      headers: getHeaders(token),
    });

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const confirmTiktokCode = async (token: string) => {
  try {
    const res = await axios.post<{ data: any }>(
      confirmTiktokCodeUrl,
      {},
      {
        headers: getHeaders(token),
      }
    );

    return res?.data?.data;
  } catch (error) {
    console.log("🚀 ~ file: apis.ts:54 ~ verifyTiktokAccount ~ error:", error);
    throw error;
  }
};

export const getConfigTiktok = async () => {
  try {
    const res = await axios.get<{ data: any }>(configTiktokUrl);

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getTiktokUserById = async (token: string, id: string) => {
  try {
    const res = await axios.get<{ data: any }>(getTiktokUserByIdUrl(id), {
      headers: getHeaders(token),
    });

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getTiktokUserHoldingsById = async (token: string, id: string) => {
  try {
    const res = await axios.get<{ data: any }>(
      getTiktokUserHoldingByIdUrl(id),
      {
        headers: getHeaders(token),
      }
    );

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getTiktokUserHoldersById = async (token: string, id: string) => {
  try {
    const res = await axios.get<{ data: any }>(
      getTiktokUserHoldersByIdUrl(id),
      {
        headers: getHeaders(token),
      }
    );

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getUserLiveInfo = async (
  token: string
): Promise<IUserLiveInfo> => {
  try {
    const res = await axios.get<IBaseResponse<IUserLiveInfo>>(getLiveInfoUrl, {
      headers: getHeaders(token),
    });

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getTiktokUserTrendingUsers = async (
  token: string,
  take: number
) => {
  try {
    const res = await axios.get<{ data: any }>(getTiktokUserTrendingUsersUrl, {
      headers: getHeaders(token),
      params: { take },
    });
    return res?.data?.data;
  } catch (error) {
    console.log(
      "🚀 ~ file: apis.ts:257 ~ getTiktokUserTrendingUser ~ error:",
      error
    );
  }
};

export const getTiktokUserUpcomingUsers = async (token: string) => {
  try {
    const res = await axios.get<{ data: any }>(getTiktokUserUpcomingUsersUrl, {
      headers: getHeaders(token),
    });
    return res?.data?.data;
  } catch (error) {
    console.log(
      "🚀 ~ file: apis.ts:257 ~ getTiktokUserTrendingUser ~ error:",
      error
    );
  }
};

export const getUserActivitiesById = async (token: string, id: string) => {
  try {
    const res = await axios.get<{ data: any }>(getUserActivitiesByIdUrl(id), {
      headers: getHeaders(token),
    });

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};
export const getUserTradeById = async (id: string) => {
  try {
    const res = await axios.get<{ data: any }>(getUserTradeByIdUrl(id), {});

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getSubscribed = async (token: string) => {
  try {
    const res = await axios.get<{ data: any }>(getSubscribedUrl, {
      headers: getHeaders(token),
      params: { take: 100, page: 0 },
    });

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getClientConfig = async () => {
  try {
    const res = await axios.get<{ data: any }>(getClientVersionUrl, {});
    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getTwitterAuthLoginUrl = async (token: string) => {
  try {
    const res = await axios.get<{ data: any }>(getTwitterAuthUrl, {
      headers: getHeaders(token),
    });

    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const postLoginTwitter = async (
  privyToken: string,
  code: string,
  state: string
) => {
  try {
    const res = await axios.post<{ data: any }>(postLoginTwitterUrl, {
      token: privyToken,
      code,
      state,
    });

    return res?.data?.data;
  } catch (error) {}
};
